/** Non-confusable alphabet (no 0/1/O/I/B/8). */
export const ROOM_CODE_ALPHABET = "2345679ADEFGHJKLMNPQRSTUVWXYZ" as const;

export const ROOM_CODE_LENGTH = 4;

const alphabetSet = new Set(ROOM_CODE_ALPHABET.split(""));

/**
 * Generate a 4-character room code.
 * Uses crypto.getRandomValues when available (Workers / modern browsers).
 */
export function generateRoomCode(): string {
  const bytes = new Uint8Array(ROOM_CODE_LENGTH);
  crypto.getRandomValues(bytes);
  let code = "";
  for (let i = 0; i < ROOM_CODE_LENGTH; i++) {
    const b = bytes[i] ?? 0;
    code += ROOM_CODE_ALPHABET[b % ROOM_CODE_ALPHABET.length];
  }
  return code;
}

/** Normalize user input (trim + uppercase). */
export function normalizeRoomCode(raw: string): string {
  return raw.trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
}

export function isValidRoomCode(raw: string): boolean {
  const code = normalizeRoomCode(raw);
  if (code.length !== ROOM_CODE_LENGTH) return false;
  for (const ch of code) {
    if (!alphabetSet.has(ch)) return false;
  }
  return true;
}
